import {useEffect, useState} from "react";
import {getCharacterById} from "@/api/CharacterApi.ts";
import {getSpell} from "@/spells/SpellApi.ts";
import {ModalContent, ModalTarget} from "@/modal/ModalHooks.ts";

interface LoadedContent {
    key: string;
    content?: ModalContent;
    error?: string;
}

export function useModalPreviewContent(target?: ModalTarget) {
    const [loaded, setLoaded] = useState<LoadedContent>();
    const type = target?.type;
    const id = target?.id;
    const key = type && id ? `${type}:${id}` : undefined;

    useEffect(() => {
        if (!type || !id || !key) return;
        const controller = new AbortController();
        const request = type === "SPELL"
            ? getSpell(id, controller.signal).then(spell => ({type, id, spell}) satisfies ModalContent)
            : getCharacterById(id, controller.signal).then(character => ({type, id, character}) satisfies ModalContent);

        void request
            .then(content => setLoaded({key, content}))
            .catch(() => {
                if (!controller.signal.aborted) {
                    setLoaded({key, error: "Der Inhalt der Vorschau konnte nicht geladen werden."});
                }
            });
        return () => controller.abort();
    }, [id, key, type]);

    const current = loaded?.key === key ? loaded : undefined;
    return {
        content: current?.content,
        loading: Boolean(key) && !current,
        error: current?.error,
    };
}
